<template lang="pug">
.about-container
    h2 关于我们
    .bar
    .img-container
        img(v-src='\'https://oss.cloud.custouch.com/res/310165/关于我们-头图.jpg?uploadAt=2025-07-28T05%3A33%3A47.9310134%2B00%3A00\'')
    p.content 圣戈班高新材料隶属于世界五百强企业圣戈班集团，由三大业务组成：工程部件、生命科学和复合材料，旨在设计和生产高性能聚合物工程产品，以满足苛刻应用环境，主要生产和销售：自润滑衬套和精密定位圈、密封件产品和聚合物、流体传输软管和氟塑料产品、泡绵与胶带等。
    p.content 凭借高性能的产品和服务，圣戈班高新材料不断为商用航天、汽车、电子半导体、新能源、工业、生命科学、建筑、食品饮料等领域提供创新型解决方案。
    p.content 我们用高性能材料，为您创造美好生活
    Icon(src='产品@3x.png', height='.7rem', name='产品大类')
    .grid-wrapper
        div 生物制药管路和耗材
        div 自润滑衬套和精密定位圈
        div 密封件和聚合物
        div 过滤器
        div 工业流体传输系统
        div 泡绵和胶带
        div 特殊涂层织物
        div 特殊膜材料
    p.content 圣戈班高新材料制造的各类高性能材料最终使人们的日常生活更加舒适、环保、高效。通过了解，您可以在生活的方方面面发现我们的产品和创新解决方案。
    .bottom(@click='push')
        .wenzi1 马上出发，与我们一起
        .wenzi2 即刻开启丰富多彩的创新材料之旅！
    a(href="https://wxcffe089aabb16bcd.wx.moseeker.com/m/position?candidate_source=0&forward_id=546a9c54dae211ebb99c00163e2ee5ff&keep=1&recom=bIRRxxxxxe&share_time=1625195127915&team_name=%E9%AB%98%E5%8A%9F%E8%83%BD%E5%A1%91%E6%96%99PPL&wechat_signature=MTgwM2U2ZmQxOTY0NTQzNmIzYTA0MmY1ZDU5MWMxNjJmN2VkYTAyYg%3D%3D#1625456755757")
        img(
            v-src='\'https://oss.cloud.custouch.com/res/35732/在招职位@3x.png\'',
            width='100%'
        )
    .qrcode-wrapper
        .item
            img(
                v-src="'https://oss.cloud.custouch.com/res/35839/PPL_China_服务号（UHD）.jpg'"
            )
            span 圣戈班高新材料<br>公众号
        .item
            img(
                v-src="'https://oss.cloud.custouch.com/res/35829/wecom-temp-e8db003e9c84f8a9352ffd16a7fb222f.jpg'"
            )
            span 圣戈班高新材料<br>招聘
</template>

<script>
import Icon from './components/icon'
export default {
    name: 'about',
    components: {
        Icon,
    },
    created() {
        this.$root.$emit('action', { name: this.$route.name })
    },
    methods: {
        push() {
            this.$router.push({
                name: 'introduce',
            })
        },
    },
}
</script>

<style scoped lang="less">
.icon {
    font-weight: 700;
}
.about-container {
    padding: 1rem;
    padding-top: 0;
    color: #07448a;
    h2 {
        font-size: 0.8rem;
        line-height: 1.1rem;
        margin-bottom: 0.5rem;
        color: #00448a;
    }
    .bar {
        width: 1.6rem;
        height: 0.25rem;
        background: #00448a;
        margin-bottom: 0.8rem;
    }
    .img-container {
        width: 100%;
        height: 9.4rem;
        margin-bottom: 0.6rem;
        img {
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 0.5rem;
        }
    }
    .content {
        font-size: 0.6rem;
        line-height: 1.1rem;
        margin-bottom: 1.2rem;
    }
    .kind-container {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 0.7rem;
        margin-bottom: 0.2rem;
        .kind {
            width: 7.9rem;
            height: 1.6rem;
            background: #f3f3f3;
            border-radius: 0.2rem;
            margin-bottom: 0.6rem;
            .text {
                font-size: 0.6rem;
                color: rgba(7, 68, 138, 1);
                line-height: 1.6rem;
                margin-left: 0.6rem;
            }
        }
    }
    .bottom {
        background: #f3f3f3;
        border-radius: 0.2rem;
        height: 3.15rem;
        margin-bottom: 1.75rem;
        padding-top: 0.5rem;
        .wenzi1,
        .wenzi2 {
            font-size: 0.7rem;
            text-align: center;
            font-weight: 700;
        }
        .wenzi2 {
            margin-top: 0.2rem;
        }
    }
}
.grid-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 0.6rem 0.9rem;
    margin: 0.7rem 0;
    div {
        background: #f3f3f3;
        border-radius: 4px;
        width: 100%;
        line-height: 1.6rem;
        padding-left: 0.6rem;
        font-size: 0.6rem;
    }
}
.qrcode-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 1.2rem;
    text-align: center;
    .item {
        display: flex;
        width: 5.4rem;
        flex-direction: column;
        &:first-child {
            margin-right: 1.6rem;
        }
    }
    img {
        width: 100%;
        object-fit: contain;
        margin-bottom: 0.3rem;
        border: 1px solid #dedede;
    }
}
</style>
